import './styles/main.scss'
import './styles/pages/_features.scss'
import './scripts/common'
import './scripts/nav'
import './scripts/footer'
import { polyfill } from './utils'
import Elevator from './models/Elevator'

polyfill()
  .then(() => {
    new Elevator('#feature-list-menu')
  })
